// Shared helpers for "log in, then come back here" flows.

// Only same-origin absolute paths are honoured, so a crafted
// ?redirect=//evil.com (or /\evil.com) can't turn login into an open redirect.
// Falls back to the account dashboard.
export function postLoginTarget() {
    if (typeof window === "undefined") {
        return "/account";
    }
    const target = new URLSearchParams(window.location.search).get("redirect");
    if (target && target.startsWith("/") && !target.startsWith("//") && !target.startsWith("/\\")) {
        return target;
    }
    return "/account";
}

// Builds a /login link that returns to the current page after signing in.
export function loginHref() {
    if (typeof window === "undefined") {
        return "/login";
    }
    const here = window.location.pathname + window.location.search;
    return `/login?redirect=${encodeURIComponent(here)}`;
}
